/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ErrorResponse,
  OrderCancellationDTO,
  OrderDTO,
  OrderDeliveryDateRejectionDTO,
  OrderDeliveryDateUpdateDTO,
  OrderSearchParamsDTO,
  OrderSearchResultDTO,
  OrderStatusUpdateDTO,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class OrderApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags order-api
   * @name AdvanceStatus
   * @summary Advance the order status (supplier only)
   * @request POST:/api/orders/{id}/advance-status
   * @secure
   */
  advanceStatus = (
    id: number,
    data: OrderStatusUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/${id}/advance-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-api
   * @name CancelOrder
   * @summary Cancel the order (both parties)
   * @request POST:/api/orders/{id}/cancel
   * @secure
   */
  cancelOrder = (
    id: number,
    data: OrderCancellationDTO,
    params: RequestParams = {},
  ) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/${id}/cancel`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-api
   * @name ConfirmDeliveryDate
   * @summary Confirm the proposed delivery date (requester only)
   * @request POST:/api/orders/{id}/confirm-delivery-date
   * @secure
   */
  confirmDeliveryDate = (id: number, params: RequestParams = {}) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/${id}/confirm-delivery-date`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-api
   * @name GetByRequest
   * @summary Get the order for a given request (for the order banner)
   * @request GET:/api/orders/by-request/{requestId}
   * @secure
   */
  getByRequest = (requestId: number, params: RequestParams = {}) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/by-request/${requestId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-api
   * @name RejectDeliveryDate
   * @summary Reject the proposed delivery date (requester only)
   * @request POST:/api/orders/{id}/reject-delivery-date
   * @secure
   */
  rejectDeliveryDate = (
    id: number,
    data: OrderDeliveryDateRejectionDTO,
    params: RequestParams = {},
  ) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/${id}/reject-delivery-date`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Returns one page of the overview together with the total hit count. Every filter and the base age hiding are applied in the database before the page is cut.
   *
   * @tags order-api
   * @name SearchOrders
   * @summary Search orders for the order tracking overview
   * @request POST:/api/orders/search
   * @secure
   */
  searchOrders = (data: OrderSearchParamsDTO, params: RequestParams = {}) =>
    this.request<OrderSearchResultDTO, ErrorResponse>({
      path: `/api/orders/search`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags order-api
   * @name UpdateDeliveryDate
   * @summary Update the confirmed delivery date (supplier only)
   * @request PUT:/api/orders/{id}/delivery-date
   * @secure
   */
  updateDeliveryDate = (
    id: number,
    data: OrderDeliveryDateUpdateDTO,
    params: RequestParams = {},
  ) =>
    this.request<OrderDTO, ErrorResponse | OrderDTO>({
      path: `/api/orders/${id}/delivery-date`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
